import { FC } from 'react'
import Icons from '@assets'
import { Field } from 'formik'
import { StyleContentWrapper, StyleBox, StyleText, StyleWrapper } from './style'
import { StyleErrorMessage } from '../style'
import Svg from '../../svg'
interface ItemProps {
  label: string
  value: string
  icon?: keyof typeof Icons
}
interface ChooseBoxProps {
  items: ItemProps[]
  name: string
  onChange?: (value: string) => void
}

const ChooseBox: FC<ChooseBoxProps> = ({ name, items, onChange }) => {
  const handleChange = ({ form, value }: any) => {
    form.setFieldValue(name, value)
    onChange && onChange(value)
  }
  return (
    <Field name={name}>
      {({ form, field, meta }: any) => {
        const hasError = !!meta.touched && !!meta.error
        return (
          <>
            <StyleWrapper>
              {items?.map((item: ItemProps) => {
                return (
                  <StyleBox
                    key={item?.value}
                    isSelected={field?.value == item?.value}
                    onClick={() => {
                      handleChange({
                        form,
                        value: item?.value,
                      })
                    }}
                  >
                    <StyleContentWrapper>
                      {!!item?.icon && <Svg svg={item?.icon} size={22} />}
                      <StyleText>{item?.label}</StyleText>
                    </StyleContentWrapper>
                    <Svg svg={'arrowRight'} size={22} />
                  </StyleBox>
                )
              })}
            </StyleWrapper>
            {!!hasError && <StyleErrorMessage>{meta?.error}</StyleErrorMessage>}
          </>
        )
      }}
    </Field>
  )
}

export default ChooseBox
